module.exports = __webpack_public_path__ + "static/a-xx-115-art-a4857b68c9ef5b7743ddfa41941f23fa.jpg";